import { render, staticRenderFns } from "./direct-withdraw-agent-modal.vue?vue&type=template&id=58540194&"
import script from "./direct-withdraw-agent-modal.vue?vue&type=script&lang=js&"
export * from "./direct-withdraw-agent-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports